import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useDownloads } from '../context/DownloadManagerContext';
import { useSettingsSheet } from '../context/SettingsSheetContext';
import '../styles/components/DownloadStrip.css';

/**
 * Persistent global indicator for the download queue — mounted once in
 * AppShell, directly above BottomPlayerBar. Renders nothing unless something
 * is queued, downloading, or has failed; otherwise it is a single button
 * that jumps straight to the downloads section of the settings sheet
 * (SettingsSheet already scrolls that section into view for
 * open('downloads')).
 */
export default function DownloadStrip() {
  const { t } = useTranslation();
  const { open } = useSettingsSheet();
  const { activeItem, pendingCount, errorCount } = useDownloads();

  // Same condition (negated) that AppShell (src/App.js) uses to toggle
  // .App's has-downloads class, read from the same two useDownloads() fields
  // — keep both in sync if this ever changes.
  if (pendingCount === 0 && errorCount === 0) return null;

  const pct = activeItem ? Math.round(activeItem.progress || 0) : 0;

  return (
    <button
      type="button"
      className="download-strip"
      onClick={() => open('downloads')}
    >
      <div className="strip-fill" style={{ width: `${pct}%` }} aria-hidden="true" />
      <div className="strip-content">
        {pendingCount > 0 && (
          <>
            <span className="strip-title">{t('downloads.active')}</span>
            <span className="strip-count">{t('downloads.remaining', { count: pendingCount })}</span>
            {activeItem && (
              <span className="strip-episode-title">{activeItem.episode.title}</span>
            )}
            <span className="strip-pct">{pct}%</span>
          </>
        )}
        {errorCount > 0 && (
          <span className="strip-failed">{t('downloads.failed', { count: errorCount })}</span>
        )}
      </div>
    </button>
  );
}
